import { useEffect, useRef } from 'react';

/**
 * Hook to lock body scroll when a modal/drawer is open.
 * Simple implementation for full-screen modals.
 *
 * @param {boolean} isLocked - Whether scroll should be locked
 */
export default function useBodyScrollLock(isLocked) {
  const scrollPositionRef = useRef(0);

  useEffect(() => {
    if (!isLocked) return;

    // Save current scroll position
    scrollPositionRef.current = window.scrollY;

    // Apply scroll lock via CSS classes
    document.body.classList.add('scroll-locked');
    document.documentElement.classList.add('scroll-locked');
    document.body.style.top = `-${scrollPositionRef.current}px`;

    return () => {
      // Remove scroll lock classes
      document.body.classList.remove('scroll-locked');
      document.documentElement.classList.remove('scroll-locked');
      document.body.style.top = '';

      // Restore scroll position
      window.scrollTo(0, scrollPositionRef.current);
    };
  }, [isLocked]);
}
